import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import {
    Checkbox,
    Container,
    FormControlLabel,
    Grid,
    Paper,
    Typography,
} from '@mui/material';
import { IParam } from '../../../../shared/types/param';
import { asyncGetIdentification } from '../../../../services/params.service';
import { useFormik } from 'formik';
import AutoCompleteField from '../../../components/general/fields/autoCompleteField';
import {
    initialValuesWeCallYou,
    validationsWeCallYou,
} from './weCallYouFormik';
import FieldText from '../../../components/general/fields/fieldText';
import {
    asyncGetWeCallYouConfig,
    asyncGetAvaibleFrimeTime,
} from '../../../../services/weCallYouAdmin.service';
import Calendar from '../../../components/general/fields/calendar';
import { asyncPostAgedmentWeCallYou } from '../../../../services/weCallYouClient.service';
import ModalUpdateWeCallYou from './modalUpdateWeCallYou';

const WeCallYouClient = () => {
    const steps: Array<string> = [
        'Ingresa tus datos',
        'Selecciona fecha y franja horaria',
        'Confirma tus datos',
    ];
    const [activeStep, setActiveStep] = useState<number>(0);
    const [identifications, setIdentifications] = useState<IParam[]>([]);
    const [timeFrameSelect, setTimeFrameSelect] = useState<number>(0);
    const [initialTimeFrameSelect, setInitialTimeFrame] = useState<any>();
    const [finalTimeFrameSelect, setFinalTimeFrame] = useState<any>();
    const [configTimeFrame, setConfigTimeFrame] = useState<any>();
    const [availableDates, setAvailableDates] = useState<Array<Date>>([]);
    const [currentDate, setCurrentDate] = useState<Date>();
    const [dateSelect, setDateSelect] = useState<string>();
    const [agedment, setAgedment] = useState<any>();
    const [openModalReAgedment, setOpenModalReAgedment] =
        useState<boolean>(false);
    const [showErrorAlert, setShowErrorAlert] = useState<boolean>(false);
    const [showSuccesfulAlert, setShowSuccesfulAlert] =
        useState<boolean>(false);
    const formik = useFormik({
        initialValues: initialValuesWeCallYou,
        validationSchema: validationsWeCallYou,
        onSubmit: async () => {
            handleNext;
        },
    });
    const handleOpenModalReAgedment = () => {
        setOpenModalReAgedment(true);
    };
    const handleCloseModalReAgedment = (result?: any) => {
        setOpenModalReAgedment(false);
        if (result.error) {
            setShowErrorAlert(true);
        } else {
            setShowSuccesfulAlert(true);
        }
    };
    const handleNext = () => {
        if (activeStep === steps.length - 1) {
            createAgedment();
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const getIdentifications = async () => {
        setIdentifications(await asyncGetIdentification());
    };
    const disabledNextStep = (): boolean => {
        switch (activeStep) {
            case 0:
                return !isFormValid();
            case 1:
                return dateSelect == undefined || timeFrameSelect == 0;
            default:
                return false;
        }
    };
    const createAgedment = async () => {
        const agedment = {
            name: formik.values.name,
            lastname: formik.values.surname,
            email: formik.values.email,
            phone: formik.values.phone,
            typeIdentification: formik.values.type_identification,
            identification: formik.values.identification,
            timeFrame: timeFrameSelect,
            date: dateSelect,
            acceptPolicy: formik.values.acceptPolicy,
            observation: formik.values.observation,
        };
        setAgedment(agedment);
        const agedmentResult: any = await asyncPostAgedmentWeCallYou(agedment);
        if (agedmentResult.errors) {
            handleOpenModalReAgedment();
        } else {
            setShowSuccesfulAlert(true);
        }
    };
    const isFormValid = () => {
        return formik.isValid && Object.keys(formik.errors).length === 0;
    };
    const getWeCallYouConfig = async () => {
        const config = await asyncGetWeCallYouConfig();
        setAvailableDates(await getDates(config));
    };
    const getConfigTimeFrame = async (date: string | undefined) => {
        setTimeFrameSelect(0);
        setConfigTimeFrame(await asyncGetAvaibleFrimeTime(date as string));
    };
    const getDates = async (config: any) => {
        const configWeCallYou = await config.items;
        if (
            !configWeCallYou ||
            !configWeCallYou.maxDates ||
            !configWeCallYou.days ||
            configWeCallYou.days.length === 0
        )
            return [];
        const result = [];
        const date = new Date();
        date.setDate(date.getDate() + 1);
        const dayNames = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
        while (result.length < configWeCallYou.maxDates) {
            const day = date.getDay();
            const dayName = dayNames[day];
            if (configWeCallYou.days.includes(dayName)) {
                result.push(new Date(date.toISOString().slice(0, 10)));
            }
            date.setDate(date.getDate() + 1);
        }
        return result;
    };
    const setSelectedDate = async (date: Date) => {
        const dateStrResult = await getDateStr(date);
        setDateSelect(dateStrResult);
        setCurrentDate(date);
        getConfigTimeFrame(dateStrResult);
    };
    const getDateStr = async (date: Date) => {
        const year = await date.getFullYear();
        const month = (await date.getMonth()) + 1;
        const day = await date.getDate();
        return `${year}-${month}-${day}`;
    };
    const resetToInitialState = () => {
        setActiveStep(0);
        setIdentifications([]);
        setTimeFrameSelect(0);
        setConfigTimeFrame(undefined);
        setAvailableDates([]);
        setCurrentDate(undefined);
        setDateSelect(undefined);
        setShowSuccesfulAlert(false);
        setShowErrorAlert(false);
        formik.resetForm();
    };
    useEffect(() => {
        resetToInitialState();
        getWeCallYouConfig();
        getIdentifications();
    }, []);

    return (
        <>
            <Box sx={{ width: '100%', maxWidth: 1500, margin: '0 auto' }}>
                <div className="container-icetex-form">
                    <div className="container icetex-form">
                        <Grid container>
                            <Grid item xs={12}>
                                <div className="icetex-title-form">
                                    <Typography variant="h2">
                                        Te llamamos
                                    </Typography>
                                </div>
                            </Grid>
                        </Grid>
                        <div className="icetex-container-form">
                            <Box sx={{ width: '100%' }}>
                                <Stepper
                                    activeStep={activeStep}
                                    alternativeLabel
                                >
                                    {steps.map((label) => (
                                        <Step
                                            key={label}
                                            sx={{
                                                '& .MuiStepLabel-root .Mui-active':
                                                    {
                                                        color: '#3366cc',
                                                    },
                                            }}
                                        >
                                            <StepLabel>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                                <div className="icetex-wecallyou-containter">
                                    <React.Fragment>
                                        {activeStep == 0 && (
                                            <Box mt={2} mb={2}>
                                                <form>
                                                    <Grid container spacing={2}>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                        >
                                                            <Box mb={1}>
                                                                <label className="icetex-label">
                                                                    Tipo de
                                                                    Identificación:
                                                                </label>
                                                            </Box>
                                                            <AutoCompleteField
                                                                data={
                                                                    identifications
                                                                }
                                                                size="small"
                                                                label="Selecciona tu Tipo de Identificacion"
                                                                name="type_identification"
                                                                touched={
                                                                    formik
                                                                        .touched
                                                                        .type_identification
                                                                }
                                                                errors={
                                                                    formik
                                                                        .errors
                                                                        .type_identification
                                                                }
                                                                value={
                                                                    formik
                                                                        .values
                                                                        .type_identification
                                                                }
                                                                onChangeValue={(
                                                                    value
                                                                ) =>
                                                                    formik.setFieldValue(
                                                                        'type_identification',
                                                                        value
                                                                    )
                                                                }
                                                                onBlur={
                                                                    formik.handleBlur
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                        >
                                                            <Box mb={1}>
                                                                <label className="icetex-label">
                                                                    Número de
                                                                    documento:
                                                                </label>
                                                            </Box>
                                                            <FieldText
                                                                label="Identificacion"
                                                                name="identification"
                                                                type="text"
                                                                size="small"
                                                                touched={
                                                                    formik
                                                                        .touched
                                                                        .identification
                                                                }
                                                                errors={
                                                                    formik
                                                                        .errors
                                                                        .identification
                                                                }
                                                                value={
                                                                    formik
                                                                        .values
                                                                        .identification
                                                                }
                                                                onChange={
                                                                    formik.handleChange
                                                                }
                                                                onBlur={
                                                                    formik.handleBlur
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                        >
                                                            <Box mb={1}>
                                                                <label className="icetex-label">
                                                                    Nombres:
                                                                </label>
                                                            </Box>
                                                            <FieldText
                                                                label="Nombres"
                                                                name="name"
                                                                type="text"
                                                                size="small"
                                                                touched={
                                                                    formik
                                                                        .touched
                                                                        .name
                                                                }
                                                                errors={
                                                                    formik
                                                                        .errors
                                                                        .name
                                                                }
                                                                value={
                                                                    formik
                                                                        .values
                                                                        .name
                                                                }
                                                                onChange={
                                                                    formik.handleChange
                                                                }
                                                                onBlur={
                                                                    formik.handleBlur
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                        >
                                                            <Box mb={1}>
                                                                <label className="icetex-label">
                                                                    Apellidos:
                                                                </label>
                                                            </Box>
                                                            <FieldText
                                                                label="Apellidos"
                                                                name="surname"
                                                                type="text"
                                                                size="small"
                                                                touched={
                                                                    formik
                                                                        .touched
                                                                        .surname
                                                                }
                                                                errors={
                                                                    formik
                                                                        .errors
                                                                        .surname
                                                                }
                                                                value={
                                                                    formik
                                                                        .values
                                                                        .surname
                                                                }
                                                                onChange={
                                                                    formik.handleChange
                                                                }
                                                                onBlur={
                                                                    formik.handleBlur
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                        >
                                                            <Box mb={1}>
                                                                <label className="icetex-label">
                                                                    Correo:
                                                                </label>
                                                            </Box>
                                                            <FieldText
                                                                label="Correo"
                                                                name="email"
                                                                type="email"
                                                                size="small"
                                                                touched={
                                                                    formik
                                                                        .touched
                                                                        .email
                                                                }
                                                                errors={
                                                                    formik
                                                                        .errors
                                                                        .email
                                                                }
                                                                value={
                                                                    formik
                                                                        .values
                                                                        .email
                                                                }
                                                                onChange={
                                                                    formik.handleChange
                                                                }
                                                                onBlur={
                                                                    formik.handleBlur
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                        >
                                                            <Box mb={1}>
                                                                <label className="icetex-label">
                                                                    Teléfono
                                                                    fijo o
                                                                    celular:
                                                                </label>
                                                            </Box>
                                                            <FieldText
                                                                label="Teléfono fijo o celular"
                                                                name="phone"
                                                                size="small"
                                                                touched={
                                                                    formik
                                                                        .touched
                                                                        .phone
                                                                }
                                                                errors={
                                                                    formik
                                                                        .errors
                                                                        .phone
                                                                }
                                                                value={
                                                                    formik
                                                                        .values
                                                                        .phone
                                                                }
                                                                onChange={
                                                                    formik.handleChange
                                                                }
                                                                onBlur={
                                                                    formik.handleBlur
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={12}
                                                            className="text-center"
                                                        >
                                                            <Box mb={1}>
                                                                <label className="icetex-label">
                                                                    Observaciones:
                                                                </label>
                                                            </Box>
                                                            <FieldText
                                                                label="Observaciones"
                                                                name="observation"
                                                                rows={6}
                                                                value={
                                                                    formik
                                                                        .values
                                                                        .observation
                                                                }
                                                                onChange={
                                                                    formik.handleChange
                                                                }
                                                                onBlur={
                                                                    formik.handleBlur
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={12}
                                                            className="text-center"
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        className="checkbox_boot"
                                                                        id="policy"
                                                                        name="aceptoPolitica"
                                                                        checked={
                                                                            formik
                                                                                .values
                                                                                .acceptPolicy
                                                                        }
                                                                        onChange={() => {
                                                                            formik.setFieldValue(
                                                                                'acceptPolicy',
                                                                                !formik
                                                                                    .values
                                                                                    .acceptPolicy
                                                                            );
                                                                        }}
                                                                        onBlur={
                                                                            formik.handleBlur
                                                                        }
                                                                    />
                                                                }
                                                                label={
                                                                    <a
                                                                        target="_blank"
                                                                        href="https://web.icetex.gov.co/atencion-al-ciudadano/politica-de-tratamiento-de-datos-personales"
                                                                    >
                                                                        Acepto
                                                                        la
                                                                        política
                                                                        de
                                                                        privacidad
                                                                        y uso de
                                                                        datos
                                                                        personales
                                                                    </a>
                                                                }
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </form>
                                            </Box>
                                        )}
                                        {activeStep == 1 && (
                                            <Box mt={2} mb={2}>
                                                <Grid
                                                    container
                                                    className="text-center"
                                                >
                                                    <Grid item xs={12} md={6}>
                                                        <Calendar
                                                            dates={
                                                                availableDates
                                                            }
                                                            onSelectDate={
                                                                setSelectedDate
                                                            }
                                                            selected={
                                                                currentDate
                                                            }
                                                        />
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        md={6}
                                                        className="grid-center text-center"
                                                    >
                                                        <Box>
                                                            {configTimeFrame &&
                                                                configTimeFrame.items.map(
                                                                    (
                                                                        timeFrame: any
                                                                    ) => {
                                                                        const startTime =
                                                                            new Date(
                                                                                `1970-01-01T${timeFrame.start}`
                                                                            );
                                                                        const endTime =
                                                                            new Date(
                                                                                `1970-01-01T${timeFrame.end}`
                                                                            );
                                                                        const startTimeStr =
                                                                            startTime.toLocaleString(
                                                                                'en-US',
                                                                                {
                                                                                    hour: 'numeric',
                                                                                    minute: '2-digit',
                                                                                    hour12: true,
                                                                                }
                                                                            );
                                                                        const endTimeStr =
                                                                            endTime.toLocaleString(
                                                                                'en-US',
                                                                                {
                                                                                    hour: 'numeric',
                                                                                    minute: '2-digit',
                                                                                    hour12: true,
                                                                                }
                                                                            );
                                                                        return (
                                                                            <div
                                                                                key={
                                                                                    timeFrame.id
                                                                                }
                                                                                className={`card-time-frame ${
                                                                                    timeFrameSelect ===
                                                                                    timeFrame.id
                                                                                        ? 'card-time-active'
                                                                                        : ''
                                                                                }`}
                                                                                onClick={() => {
                                                                                    setTimeFrameSelect(
                                                                                        timeFrame.id
                                                                                    );
                                                                                    setInitialTimeFrame(
                                                                                        startTimeStr
                                                                                    );
                                                                                    setFinalTimeFrame(
                                                                                        endTimeStr
                                                                                    );
                                                                                }}
                                                                            >
                                                                                <Typography>
                                                                                    {`${startTimeStr} - ${endTimeStr}`}
                                                                                </Typography>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        )}
                                        {activeStep == 2 && (
                                            <Box mt={2} mb={2}>
                                                <Container className="mt-5">
                                                    <Grid
                                                        container
                                                        justifyContent="center"
                                                    >
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={9}
                                                        >
                                                            <Grid container>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={4}
                                                                >
                                                                    <Box
                                                                        padding={
                                                                            2
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            className="label-info-icetex"
                                                                            variant="h2"
                                                                        >
                                                                            Número
                                                                            de
                                                                            identificación
                                                                        </Typography>
                                                                        <Typography>
                                                                            {
                                                                                formik
                                                                                    .values
                                                                                    .identification
                                                                            }
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={4}
                                                                >
                                                                    <Box
                                                                        padding={
                                                                            2
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            className="label-info-icetex"
                                                                            variant="h2"
                                                                        >
                                                                            Nombres
                                                                            y
                                                                            apellidos
                                                                        </Typography>
                                                                        <Typography>{`${formik.values.name} ${formik.values.surname}`}</Typography>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={4}
                                                                >
                                                                    <Box
                                                                        padding={
                                                                            2
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            className="label-info-icetex"
                                                                            variant="h2"
                                                                        >
                                                                            Correo
                                                                            electrónico
                                                                        </Typography>
                                                                        <Typography>
                                                                            {
                                                                                formik
                                                                                    .values
                                                                                    .email
                                                                            }
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                            <br />
                                                            <br />
                                                            <Grid container>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={4}
                                                                >
                                                                    <Box
                                                                        padding={
                                                                            2
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            className="label-info-icetex"
                                                                            variant="h2"
                                                                        >
                                                                            Teléfono
                                                                            fijo
                                                                            o
                                                                            celular
                                                                        </Typography>
                                                                        <Typography>
                                                                            {
                                                                                formik
                                                                                    .values
                                                                                    .phone
                                                                            }
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={4}
                                                                >
                                                                    <Box
                                                                        padding={
                                                                            2
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            className="label-info-icetex"
                                                                            variant="h2"
                                                                        >
                                                                            Fecha
                                                                            de
                                                                            agendamiento
                                                                        </Typography>
                                                                        <Typography>
                                                                            {
                                                                                dateSelect
                                                                            }
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={4}
                                                                >
                                                                    <Box
                                                                        padding={
                                                                            2
                                                                        }
                                                                    >
                                                                        <Typography
                                                                            className="label-info-icetex"
                                                                            variant="h2"
                                                                        >
                                                                            Franja
                                                                            horaria
                                                                            seleccionada
                                                                        </Typography>
                                                                        <Typography>
                                                                            {`${initialTimeFrameSelect} - ${finalTimeFrameSelect}`}
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                            {showSuccesfulAlert && (
                                                                <Paper
                                                                    variant="outlined"
                                                                    sx={{
                                                                        mt: 2,
                                                                        p: 2,
                                                                        backgroundColor:
                                                                            '#dff0d8',
                                                                        borderColor:
                                                                            '#d0e9c6',
                                                                        color: '#3c763d',
                                                                    }}
                                                                >
                                                                    Su llamada
                                                                    ha sido
                                                                    programada
                                                                    para el{' '}
                                                                    {dateSelect}
                                                                    .
                                                                </Paper>
                                                            )}
                                                            {showErrorAlert && (
                                                                <Paper
                                                                    variant="outlined"
                                                                    sx={{
                                                                        mt: 2,
                                                                        p: 2,
                                                                        backgroundColor:
                                                                            '#f2dede',
                                                                        borderColor:
                                                                            '#ebccd1',
                                                                        color: '#a94442',
                                                                    }}
                                                                >
                                                                    Lo sentimos,
                                                                    no pudimos
                                                                    agendar la
                                                                    llamada en
                                                                    este
                                                                    momento. Por
                                                                    favor,
                                                                    inténtelo
                                                                    nuevamente
                                                                    más tarde.
                                                                </Paper>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Container>
                                            </Box>
                                        )}
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    className="icetex-btn-secundary"
                                                    color="inherit"
                                                    disabled={activeStep === 0}
                                                    onClick={handleBack}
                                                    sx={{ width: '90%' }}
                                                >
                                                    Volver
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Button
                                                    className="icetex-btn-primary"
                                                    disabled={disabledNextStep()}
                                                    onClick={handleNext}
                                                    sx={{ width: '90%' }}
                                                >
                                                    {activeStep ===
                                                    steps.length - 1
                                                        ? 'Agendar llamada'
                                                        : 'Siguiente'}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                </div>
                            </Box>
                        </div>
                    </div>
                </div>
            </Box>
            <ModalUpdateWeCallYou
                openModalReAgedment={openModalReAgedment}
                agedment={agedment}
                handleCloseModalReAgedment={(result) =>
                    handleCloseModalReAgedment(result)
                }
            />
        </>
    );
};

export default WeCallYouClient;
